export default "__VITE_ASSET__IuzFNlah__"